import axios from 'axios';

import { buildEndpoint, getAuthToken } from '@services/service';

const BASE_SUBSCRIPTIONS_URL = process.env
    .REACT_APP_SUBSCRIPTIONS_URL as string;

const deletePlan = async (id: number) => {
    try {
        const endpoint = buildEndpoint(
            BASE_SUBSCRIPTIONS_URL,
            `/api/admin/plans/${id}`
        );
        const response = await axios.delete(endpoint, {
            headers: { Authorization: getAuthToken() },
        });
        return response.data;
    } catch (err) {
        console.error('Error deleting plan:', err);
        return { deleted: false };
    }
};

export { deletePlan };
